module.exports = __webpack_public_path__ + "img/AO.61eb7d54.svg";